// Centralized brand & content constants for PEG Serviços
export const BRAND = {
    name: "PEG Serviços",
    tagline: "Movendo pessoas. Criando caminhos.",
    sub: "Onde a clareza guia e a atitude transforma.",
    instagram: "https://instagram.com/pegservicos",
    instagramHandle: "@pegservicos",
    region: "Bahia, Brasil",
    cnpj: "26.102.377/0001-45",
    email: "peglocadora@outlook.com",
    address: {
        line: "Av. Zeca Miranda, 254 — Lagoa Grande",
        city: "Bom Jesus da Lapa/BA",
        zip: "CEP 47.600-000",
        mapsUrl:
            "https://www.google.com/maps/search/?api=1&query=Av.+Zeca+Miranda+254+Lagoa+Grande+Bom+Jesus+da+Lapa+BA",
        embedUrl:
            "https://www.google.com/maps?q=Av.%20Zeca%20Miranda%2C%20254%20-%20Lagoa%20Grande%2C%20Bom%20Jesus%20da%20Lapa%20-%20BA%2C%2047600-000&output=embed",
    },
    colors: {
        yellow: "#fec200",
        light: "#f5f5f5",
        dark: "#1a1a1a",
    },
    logo: "https://customer-assets.emergentagent.com/job_peg-rastreio/artifacts/mdxry3fd_WhatsApp_Image_2026-06-02_at_12.00.08-2-removebg-preview.png",
    logoDark: "https://customer-assets.emergentagent.com/job_peg-rastreio/artifacts/ycurgqix_ChatGPT_Image_9_de_jun._de_2026__19_01_42-removebg-preview.png",
    mascot: "https://customer-assets.emergentagent.com/job_peg-rastreio/artifacts/pqxmoeyr_WhatsApp%20Image%202026-06-05%20at%2007.12.43.jpeg",
};

export const PHONES = {
    aluguel: { label: "Aluguel de Carros", raw: "5577999002000", display: "(77) 99900-2000" },
    rastreamento: { label: "Rastreamento Veicular", raw: "5577991302000", display: "(77) 99130-2000" },
    guincho: { label: "Guincho 24h", raw: "5577991302000", display: "(77) 99130-2000" },
};

export const buildWhatsAppLink = (rawPhone, message) =>
    `https://wa.me/${rawPhone}?text=${encodeURIComponent(message)}`;

export const buildTelLink = (rawPhone) => `tel:+${rawPhone}`;

export const SERVICES = [
    {
        slug: "aluguel",
        path: "/aluguel-de-veiculos",
        title: "Aluguel de Veículos",
        short: "Locação prática, segura e com excelente custo-benefício para pessoas e empresas.",
        long:
            "Oferecemos veículos revisados e prontos para atender necessidades pessoais e corporativas. Nossa frota diversificada e planos flexíveis garantem a melhor experiência de locação.",
        icon: "Car",
        phone: PHONES.aluguel,
        benefits: [
            "Frota diversificada e moderna",
            "Veículos revisados e higienizados",
            "Planos diários, semanais e mensais",
            "Atendimento ágil e sem burocracia",
            "Locação para pessoas físicas e empresas",
            "Documentação 100% em dia",
        ],
        image:
            "https://customer-assets.emergentagent.com/job_peg-rastreio/artifacts/q3mx20ag_ChatGPT%20Image%209%20de%20jun.%20de%202026%2C%2019_00_29.png",
        video:
            "https://customer-assets.emergentagent.com/job_peg-rastreio/artifacts/85lukabe_WhatsApp%20Video%202026-06-08%20at%2015.55.09.mp4",
        cta: "Saiba mais sobre Locação",
        whatsappMessage:
            "Olá! Tenho interesse no aluguel de veículos da PEG Serviços. Gostaria de receber um orçamento.",
    },
    {
        slug: "rastreamento",
        path: "/rastreamento-veicular",
        title: "Rastreamento Veicular",
        short: "Monitore seu veículo em tempo real com tecnologia avançada e total controle.",
        long:
            "Mais segurança para carros, motos, caminhões e frotas empresariais. Tecnologia de ponta, aplicativo intuitivo e alertas em tempo real para você sempre saber onde está o seu patrimônio.",
        icon: "MapPin",
        phone: PHONES.rastreamento,
        benefits: [
            "Monitoramento 24 horas",
            "Aplicativo completo para iOS e Android",
            "Histórico detalhado de rotas",
            "Alertas em tempo real",
            "Bloqueio remoto do veículo",
            "Ideal para gestão de frotas",
        ],
        image:
            "https://customer-assets.emergentagent.com/job_peg-rastreio/artifacts/6uoc3puh_WhatsApp%20Image%202026-06-04%20at%2006.55.30%20%281%29.jpeg",
        instagramEmbed: "https://www.instagram.com/reel/CwxztAkOXTh/embed",
        appScreenshot:
            "https://customer-assets.emergentagent.com/job_peg-rastreio/artifacts/ugwwl7pq_WhatsApp%20Image%202026-06-08%20at%2015.46.55.jpeg",
        cta: "Conheça o Rastreamento",
        whatsappMessage:
            "Olá! Tenho interesse no rastreamento veicular da PEG Serviços. Pode me passar mais informações?",
    },
    {
        slug: "guincho",
        path: "/guincho-24-horas",
        title: "Guincho 24 Horas",
        short: "Atendimento rápido e eficiente para situações emergenciais. Sempre que você precisar.",
        long:
            "Estamos preparados para ajudar quando você mais precisa, 24 horas por dia, 7 dias por semana. Equipe treinada, equipamentos modernos e cobertura regional em toda a Bahia.",
        icon: "Wrench",
        phone: PHONES.guincho,
        benefits: [
            "Atendimento 24h, todos os dias",
            "Cobertura em toda a Bahia",
            "Remoção de veículos leves e pesados",
            "Equipe especializada e treinada",
            "Agilidade no atendimento",
            "Equipamentos modernos e seguros",
        ],
        image:
            "https://customer-assets.emergentagent.com/job_peg-rastreio/artifacts/mxrnh8y0_WhatsApp%20Image%202026-06-08%20at%2015.59.10.jpeg",
        cta: "Solicitar Guincho Agora",
        whatsappMessage:
            "Olá! Preciso de um guincho com urgência. Pode me atender?",
    },
];

export const DIFERENCIAIS = [
    "Atendimento rápido",
    "Equipe especializada",
    "Cobertura ampla",
    "Tecnologia de ponta",
    "Segurança e confiabilidade",
    "Suporte humanizado",
];

export const PORQUE = [
    {
        title: "Segurança",
        text: "Processos confiáveis e suporte especializado em todas as etapas.",
        icon: "ShieldCheck",
    },
    {
        title: "Agilidade",
        text: "Atendimento rápido para reduzir o seu tempo de espera ao mínimo.",
        icon: "Zap",
    },
    {
        title: "Tecnologia",
        text: "Ferramentas modernas para garantir eficiência e total controle.",
        icon: "Cpu",
    },
    {
        title: "Experiência",
        text: "Equipe preparada para oferecer as melhores soluções do mercado.",
        icon: "Award",
    },
];

export const TESTIMONIALS = [
    {
        name: "Mariana Costa",
        role: "Empresária — Vitória da Conquista/BA",
        text:
            "Aluguei um veículo da PEG para uma viagem corporativa e fui surpreendida pela qualidade do carro e pelo atendimento humano. Voltarei sempre que precisar.",
        service: "Aluguel de Veículos",
    },
    {
        name: "Roberto Almeida",
        role: "Gestor de Frota — Salvador/BA",
        text:
            "Implantamos o rastreamento da PEG em toda nossa frota de entregas. O aplicativo é simples, as informações chegam em tempo real e tivemos uma redução real nos custos.",
        service: "Rastreamento Veicular",
    },
    {
        name: "João Silva",
        role: "Motorista de aplicativo — Feira de Santana/BA",
        text:
            "Furei o pneu na BR de madrugada. Liguei pra PEG e em pouco tempo o guincho chegou. Profissionais educados e ágeis. Salvou minha noite.",
        service: "Guincho 24h",
    },
    {
        name: "Camila Ferreira",
        role: "Designer — Ilhéus/BA",
        text:
            "Atendimento impecável do início ao fim. A retirada do carro foi rápida, sem burocracia, e o preço encaixou no meu orçamento. Recomendo de olhos fechados.",
        service: "Aluguel de Veículos",
    },
    {
        name: "Lucas Mendes",
        role: "Transportadora Mendes — Barreiras/BA",
        text:
            "Tenho 14 caminhões rastreados pela PEG. A tranquilidade que isso me dá não tem preço. Suporte sempre disponível e tecnologia confiável.",
        service: "Rastreamento Veicular",
    },
    {
        name: "Ana Beatriz",
        role: "Médica — Porto Seguro/BA",
        text:
            "Bateria descarregou no estacionamento do hospital. Em 20 minutos a equipe da PEG estava lá. Atendimento humano e muito profissional.",
        service: "Guincho 24h",
    },
];
